import { Outlet } from 'react-router'

import { AppSidebar } from '@/components/app-sidebar'
import { ErrorState } from '@/components/ErrorState'
import { Loading } from '@/components/Loading'
import { SiteHeader } from '@/components/site-header'
import { SubscriptionBanner } from '@/components/SubscriptionBanner'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { PageHeaderProvider } from '@/contexts/PageHeaderContext'
import { useAuth } from '@/lib/auth'

export const AppLayout = () => {
  return (
    <Auth>
      <PageHeaderProvider>
        <div className="[--header-height:calc(theme(spacing.12))]">
          <SidebarProvider className="flex flex-col">
            <SiteHeader />
            <SubscriptionBanner />
            <div className="flex flex-1">
              <AppSidebar />
              <SidebarInset className="min-w-0 px-6 py-6 lg:px-8">
                <Outlet />
              </SidebarInset>
            </div>
          </SidebarProvider>
        </div>
      </PageHeaderProvider>
    </Auth>
  )
}

function Auth({ children }: { children: React.ReactNode }) {
  const { isLoading, error } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'AppLayout',
  })

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loading />
      </div>
    )
  }

  if (error) {
    console.log(error)
    return <ErrorState>
      <h1>Error</h1>
      <p>
        {error.message}
      </p>
    </ErrorState>
  }

  return children
}

AppLayout.displayName = 'AppLayout'
